// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1U8j5","info":"Note_info__a3RIu","note":"Note_note__3vBmL","actions":"Note_actions__3rNti"};